import _                        from 'underscore';
import classNames               from 'classnames';
import React, { FC, ReactNode } from 'react';
import { Divider, Segment }     from 'semantic-ui-react';

import { StyledContainer }                                       from './';
import { Size }                                                  from '../../types';
import { BottomProgressionNavBar, BottomProgressionNavBarProps } from '../containers/BottomProgressionNavBar';
import { PAGE }                                                  from '../../constants/UIEnums';
import { Cell, Grid }                                            from 'styled-css-grid';

export interface GenericContentLayoutProps {
	
	/* Visually show navigation if no progression is set? */
	navigation?: BottomProgressionNavBarProps,
	
	/* Should the layout include an upper right area? */
	withTopSideArea?: boolean,
	
	/* Upper left area side component */
	topAreaComponent?: ReactNode,
	
	/* Upper right area side component */
	topSideAreaComponent?: ReactNode,
	
	/* Should the layout make the top sidearea sticky as the user scrolls? */
	topSideAreaIsSticky?: boolean,
	
	/* Where should the layout for top side area stick to positionally as the user scrolls? */
	topSideAreaStickyTop?: number,
	
	/* Should the layout include a lower right area? */
	withBottomSideArea?: boolean,
	
	/* Lower left area side component */
	bottomSideAreaComponent?: ReactNode,
	
	/* Should the layout make the bottom side area sticky as the user scrolls? */
	bottomSideAreaIsSticky?: boolean,
	
	/* Where should the layout for bottom side area stick to positionally as the user scrolls? */
	bottomSideAreaStickyTop?: number,
	
	/* Should the layout make the top areas present in reverse? */
	reverseTopAreas?: boolean,
	
	/* Should the layout make the lower areas present in reverse? */
	reverseBottomAreas?: boolean,
	
	/* Should the layout make the top and bottom areas the same area? */
	mergeTopAndBottomAreas?: boolean,
	
	/* Split the top and bottom areas with a divider? */
	withDivider?: boolean,
	
	[ additionalProps: string ]: any
}

const defaultProps: GenericContentLayoutProps = {
	navigation: null,
	
	topAreaComponent:   null,
	withTopSideArea:    true,
	withBottomSideArea: true,
	
	topSideAreaComponent: null,
	topSideAreaIsSticky:  false,
	topSideAreaStickyTop: null,
	
	bottomSideAreaComponent: null,
	bottomSideAreaIsSticky:  true,
	bottomSideAreaStickyTop: null,
	
	reverseBottomAreas: false,
	reverseTopAreas:    false,
	
	withDivider: false,
}

const GenericContentLayout: FC<GenericContentLayoutProps> = ( props ) => {
	
	let generateGridProps = () => {
		
		return {
			columns:   4,
			columnGap: `50px`,
			rows:      `auto auto`,
			rowGap:    `10px`,
			areas:     _.compact(
				props.mergeTopAndBottomAreas ? [
					
					!props.withTopSideArea ? 'main main main main'
					                       : props.reverseTopAreas
					                         ? 'side main main main'
					                         : 'main main main side',
				
				] : [
					
					!props.withTopSideArea ? 'topMain topMain topMain topMain'
					                       : props.reverseTopAreas
					                         ? 'topSide topMain topMain topMain'
					                         : 'topMain topMain topMain topSide',
					
					props.withDivider ? `divider divider divider divider` : null,
					
					!props.withBottomSideArea ? 'bottomMain bottomMain bottomMain bottomMain'
					                          : props.reverseBottomAreas
					                            ? 'bottomSide bottomMain bottomMain bottomMain'
					                            : 'bottomMain bottomMain bottomMain bottomSide'
				] )
		}
	}
	
	let gridAreaConfig = generateGridProps();
	
	return (
		<div className={ 'margin-xl-bottom' }>
			
			{ props.navigation && (
				
				<BottomProgressionNavBar { ...props.navigation }/>
			
			) }
			
			
			{ !props.mergeTopAndBottomAreas ? (
				
				<Grid { ...gridAreaConfig }>
					
					<Cell area={ 'topMain' }>
						{ props.topAreaComponent }
					</Cell>
					
					{ props.withTopSideArea && (
						<Cell area={ 'topSide' }>
							
							<StyledContainer className={ classNames( { 'position--sticky': props.topSideAreaIsSticky } ) } style={ props.topSideAreaIsSticky ? { top: props.topSideAreaStickyTop ?? PAGE.STICKY_CONTENT_TOP } : {} }>
								{ props.topSideAreaComponent }
							</StyledContainer>
						
						</Cell>
					) }
					
					{ ( props.withDivider ) && (
						<Cell area={ 'divider' }>
							<Divider/>
						</Cell>
					) }
					
					<Cell area={ 'bottomMain' }>
						{ props.children }
					</Cell>
					
					{ props.withBottomSideArea && (
						<Cell area={ 'bottomSide' }>
							
							<StyledContainer className={ classNames( { 'position--sticky': props.bottomSideAreaIsSticky } ) } style={ props.bottomSideAreaIsSticky ? { top: props.bottomSideAreaStickyTop ?? PAGE.STICKY_CONTENT_TOP } : {} }>
								{ props.bottomSideAreaComponent }
							</StyledContainer>
						
						</Cell>
					) }
				</Grid>
			
			) : (
				
				  <Grid { ...gridAreaConfig }>
					
					  <Cell area={ 'main' }>
						
						  { props.children }
					
					  </Cell>
					
					  { props.withTopSideArea && (
						  <Cell area={ 'side' }>
							
							  <StyledContainer className={ classNames( { 'position--sticky': props.topSideAreaIsSticky } ) } style={ props.topSideAreaIsSticky ? { top: props.topSideAreaStickyTop ?? PAGE.STICKY_CONTENT_TOP } : {} }>
								  { props.topSideAreaComponent }
							  </StyledContainer>
						
						  </Cell>
					  ) }
				
				  </Grid>
			
			  ) }
		
		</div>
	);
};

GenericContentLayout.defaultProps = defaultProps;

export { GenericContentLayout }
